import { motion } from 'framer-motion'
import type { SlideProps } from '@/components/SlideWizard'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide1Insight.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide1Insight(_props: SlideProps) {
  const c = useSlideCopy(copy)
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 mx-auto max-w-4xl">
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2, ease }}
        className="text-3xl sm:text-5xl font-semibold text-slate-900 tracking-tight leading-[1.1] max-w-4xl text-balance"
      >
        {c.headlineBefore}
        <span className="font-semibold text-slate-900 italic">{c.headlineEmphasis}</span>
      </motion.p>

      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.6, ease }}
        className="mt-8 text-xl sm:text-2xl text-slate-500 leading-relaxed max-w-3xl"
      >
        {c.body}
      </motion.p>
    </div>
  )
}
